import { useCallback, useRef, useState, useEffect } from 'react'

import { useAppDispatch } from '@/store'
import { updateExecutionEvents } from '@/features/domain/order'
import { useNotification } from '@/hooks'
import { useResetEditingState } from '@/atoms'

export const useOnUpdateExecutionEvents = () => {
  const dispatch = useAppDispatch()

  const stopEditing = useResetEditingState()

  const mounted = useRef<boolean>(false)
  const [submitting, setSubmitting] = useState<boolean>(false)
  const toast = useNotification()

  const onUpdateExecutionEvents = useCallback(
    async (updateRequest: uui.domain.ui.forms.ExecutionEventsChanges, pristine?: boolean) => {
      try {
        if (pristine) {
          stopEditing()
          return
        }

        setSubmitting(true)

        const thunkResult = await dispatch(updateExecutionEvents(updateRequest))

        if (mounted.current) {
          setSubmitting(false)
        }

        if (!updateExecutionEvents.fulfilled.match(thunkResult)) {
          throw new Error(thunkResult.payload?.message ?? 'Internal error')
        }

        stopEditing()
      } catch (e) {
        toast.error(e.message)
      }
    },
    [dispatch, stopEditing, toast],
  )

  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
    }
  }, [])

  return {
    submitting,
    onUpdateExecutionEvents,
  }
}
